import * as React from 'react';
import type { ReactNode } from 'react';

export const useAccordionContentRenderer = (children: ReactNode, lazy: boolean, expanded: boolean) => {
    const [shouldRenderContent, setShouldRenderContent] = React.useState(!lazy);

    React.useEffect(() => {
        setShouldRenderContent(!lazy || expanded);
    }, [lazy]);

    const onToggleClick = () => {
        if (lazy && !shouldRenderContent) {
            setShouldRenderContent(true);
        }
    };

    const onCollapsed = () => {
        if (lazy && !expanded) {
            setShouldRenderContent(false);
        }
    };

    return {
        content: shouldRenderContent ? children : null,
        onToggleClick,
        onCollapsed,
    };
};
